import { createSlice } from "@reduxjs/toolkit";

import {
  fetchPetsData,
  deletePetData,
  updatePetData,
  getPetDetailData,
  AddPetsData,
} from "../thunks/petsThunks"; // Ensure correct import

interface PetsListState {
  petsList: any[];
  petsDetail: any;
  loading: boolean;
  error: string | null;
  petsAddDetail: any;
  total: number;
}

const initialState: PetsListState = {
  petsList: [],
  loading: false,
  petsDetail: {}, // Add a new property to hold pet detail
  error: null,
  petsAddDetail: null,
  total: 0,
};

export const petsSlice = createSlice({
  name: "pets", // Consistent with the slice usage
  initialState,
  reducers: {
    clearPetsError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPetsData.pending, (state) => {
        // Updated thunk name
        state.loading = true;
        state.error = null; // Reset error on new request
      })
      .addCase(fetchPetsData.fulfilled, (state, action) => {
        state.petsList = action.payload?.data || [];
        state.loading = false;
        state.total = action.payload.total;
      })
      .addCase(fetchPetsData.rejected, (state, action) => {
        state.error = (action.payload as string) || "Something went wrong";
        state.loading = false;
      });
    builder
      .addCase(deletePetData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePetData.fulfilled, (state, action) => {
        state.loading = false;
        // Option 2: If your payload contains the ID as 'id'
        if (action.payload.id) {
          state.petsList = state.petsList.filter(
            (pet) => pet.pets_id !== action.payload?.id
          );
        }
      })
      .addCase(deletePetData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
    builder
      .addCase(updatePetData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePetData.fulfilled, (state, action) => {
        state.loading = false;
        state.petsList = state.petsList.map((pets) => {
          if (pets.pets_id === action.payload?.pets_id) {
            return { ...pets, ...action.payload };
          }
          return pets;
        });
        if (state.petsAddDetail?.pets_id === action.payload.pets_id) {
          console.log("Updating petsAddDetail with new data:", action.payload);
          state.petsAddDetail = { ...state.petsAddDetail, ...action.payload };
        }
      })
      .addCase(updatePetData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
    builder
      .addCase(getPetDetailData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPetDetailData.fulfilled, (state, action) => {
        state.loading = false;
        state.petsDetail = action.payload;
      })
      .addCase(getPetDetailData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
    builder
      .addCase(AddPetsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddPetsData.fulfilled, (state, action) => {
        state.loading = false;
        state.petsAddDetail = action.payload;
      })
      .addCase(AddPetsData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
  },
});

export const { clearPetsError } = petsSlice.actions;
export default petsSlice.reducer;
